"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ConditionalParamsModule = require("../../modules/ConditionalParamsModule");
var _useQueryParams = _interopRequireDefault(require("../../packages/useQueryParams"));
var _jsxRuntime = require("react/jsx-runtime");
const RenderContent = function (_ref) {
  let {
    query,
    visibility = "true",
    children,
    mockParams
  } = _ref;
  const boolVis = visibility === "true";
  const queryParameters = (0, _useQueryParams.default)();
  const queryParams = mockParams || queryParameters;
  const queryResult = (0, _ConditionalParamsModule.renderEval)(queryParams, query);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: boolVis === queryResult && children
  });
};
var _default = exports.default = RenderContent;